export default __webpack_public_path__ + "static/media/tiktok.a4b1e012.svg";